class User {
  constructor(name) {
    this.name = name
    this.done = []
  }
  addFinishedLesson(lesson) {
      this.done.push(lesson)
  }
  getNumberOfCompleted() {
    return this.done.length
  }
}

export default User
